import { render, staticRenderFns } from "./InputTextEl.vue?vue&type=template&id=08591fee&"
import script from "./InputTextEl.vue?vue&type=script&lang=ts&"
export * from "./InputTextEl.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextEl.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
